import vp from './vp'

export default {
  addBtn: 'Add Event',
  eventDescription:
    'Better not to modify the parameters of the timming trigger, they may affect the playabilities.',
  eventComponent: {
    eventPosition: {
      updatePositionBtn: 'Position is set to current value',
    },
    unit: {
      ShakeFequence: 'times/s',
    },
    showElement: 'Show material',
    hideElement: 'Hide material',
    enablePair: 'Enable Pairing',
    banPair: 'Disable Pairing',
    freeEnable: 'Enable Draw Lines Component',
    freeBan: 'Disable Draw Lines Component',
    showGroup: 'Show Group',
    hideGroup: 'Hide Group',
    enableEraseGroup: 'Enable Erasable Group',
    banEraseGroup: 'Disable Erasable Group',
    enableEraseComponent: 'Enable Erase Component',
    banEraseComponent: 'Disable Erase Component',
    enableMaskComponent: 'Enable Mask Component',
    banMaskComponent: 'Disable Mask Component',
    enableMaskGroupComponent: 'Enable Mask Group',
    banMaskGroupComponent: 'Disable Mask Group',
    showMaskGroup: 'Show Mask Group',
    hideMaskGroup: 'Hide Mask Group',
    showMaskSubGroup: 'Show Group',
    hideMaskSubGroup: 'Hide Group',
    enableMaskShape: 'Enable Mask Effect',
    banMaskShape: 'Disable  Mask Effect',
    enableCarouselComponent: 'Enable Carousel Component',
    banCarouselComponent: 'Disable Carousel Component',
    enableCarousel: 'Enable Carousel Group',
    banCarousel: 'Disable Carousel Group',
    pauseCarousel: 'Pause Carousel Group',
    playCarousel: 'Play Carousel Group',
  },
  eventBlock: {
    editBtn: 'Edit the drag area',
    addBtn: '+Add designated area',
    eventTitle: 'Response event',
    placeholder: 'Select response event',
    targetTitle: 'Response object',
    targetInfo: 'Required information',
    saveBtn: 'Save',
    cancelBtn: 'Cancel',
    addAction: '+ Add response event',
    timerEvent: 'Timer',
    jumpToScene: 'Redirect to the specified scene',
    jumpNextScene: 'Redirect to the next scene',
    jumpAppStore: 'Redirect to app store',
    setBuriedPoint: 'Set Tracking Event',
    setPosition: 'Set location',
    setSpin: 'Set rotation',
    setWidth: 'Set width',
    setHeight: 'Set height',
    materialDisplay: 'Show/hide material',
    setTransparency: 'Set transparency',
    setColor: 'Set color',
    executionDelay: 'Execution delay',
    cancelDelay: 'Cancel execution delay',
    dragDirTitle: 'Drag Direction',
    xDragDir: 'Horizontal Direction',
    yDragDir: 'Vertical Direction',
    anyDragDir: 'Any Direction',
    dragBound: 'Draggable Range',
    dragBoundFullScreen: 'Full Screen',
    dragBoundCustom: 'Custom',
    dragBoundCustomDesc: 'Resizable in the Canvas',
    dragAreaTip: 'Specified Area',
    dragBoundTip: 'Custom Draggable Range',
    dragTip:
      'For the same layer, under different drag events, the drag-related settings should remain consistent, including drag range and drag direction. The latest settings will be applied.',
    dragResetPos: 'Release Reset',
    yes: 'Yes',
    no: 'No',
  },
  eventHand: {
    click: 'Click',
    hold: 'Long press 3s',
    down: 'Press',
    up: 'Lift up',
    doubleClick: 'Double click',
    swipeUp: 'Slide up',
    swipeDown: 'Slide down',
    swipeLeft: 'Slide left',
    swipeRight: 'Slide right',
    swipeAny: 'Swipe arbitrarily',
    vpDragStart: 'Drag',
    vpDragPosition: 'Drag to target position',
    vpUnDragPosition: 'Not dragged to target position',
    dragArea: 'Drag the designated area',
    delay: 'Timing trigger',
    customEvent: 'Custom Event',
    videoStart: 'Starting time',
    videoEnd: 'Ending time',
    audioStart: 'Starting time',
    audioEnd: 'Ending time',
    hideUI: 'Hidden element',
    installApp: 'Download app',
    switchScene: 'switch Scene',
    fromStatus: 'Start',
    toStatus: 'End',
    longPress: 'Long Press',
    conditionIf: 'Condition',
    drawStart: 'Begin Drawing',
    drawEnd: 'Finish Drawing',
    freeDrawStart: 'Begin Drawing',
    freeDrawEnd: 'Finish Drawing',
    eraseStart: 'Start Erasing',
    eraseUp: 'Lift Finger',
    eraseReachStep: 'Reach a certain stage',
    eraseUnReachStep: 'Not reached a certain stage',
  },
  eventTarget: {
    placeholder: 'Select the respondent',
  },
  visualProgram: {
    variableType: {
      string: 'String',
      number: 'Number',
      boolean: 'Boolean',
    },
  },
  action: vp.action,
  VpCategories: vp.VpCategories,
  component: vp.component,
}
